<template>
  <div class="modal-card" style="width: 1200px">
    <header class="modal-card-head">
      <p class="modal-card-title is-centered">
        {{ $t('attributes.add') + $t('attributes.product') }}
      </p>
    </header>
    <section class="modal-card-body">
      <b-steps
        v-model="activeStep"
        rounded
        :has-navigation="false"
        :mobile-mode="null"
      >
        <b-step-item step="1" label="設定資料" :clickable="false">
          <create-form
            ref="createForm"
            :is-sending="isSending"
            :loading.sync="loadingAreas"
            @onSend="onSend"
          />
        </b-step-item>

        <b-step-item step="2" label="設定旅客類型" :clickable="false">
          <traveler-type-list
            ref="travelerTypeList"
            v-if="activeStep === 1"
            :product="product"
          ></traveler-type-list>
        </b-step-item>

        <b-step-item step="3" label="設定方案價格" :clickable="false">
          <plan-list
            ref="planList"
            v-if="activeStep === 2"
            :product="product"
          ></plan-list>
        </b-step-item>
      </b-steps>

      <b-loading :active="loading" :is-full-page="false" :can-cancel="false" />
    </section>

    <footer class="modal-card-foot">
      <div class="buttons is-right" style="width: 100%;">
        <b-button
          v-if="activeStep === 0"
          :loading="loading"
          @click="$parent.close()"
        >
          {{ $t('attributes.cancel') }}
        </b-button>
        <b-button
          v-if="activeStep === 0"
          :loading="loading"
          type="is-primary"
          @click.prevent="onCreate"
        >
          {{ $t('attributes.add') }}
        </b-button>
        <b-button
          v-if="activeStep === 1"
          :loading="loading"
          type="is-primary"
          @click.prevent="onNext"
        >
          {{ $t('attributes.next') }}
        </b-button>
        <b-button
          v-if="activeStep === 2"
          :loading="loading"
          type="is-primary"
          @click.prevent="onCompleted"
        >
          {{ $t('attributes.complete') }}
        </b-button>
      </div>
    </footer>
  </div>
</template>

<script>
import CreateForm from '@/components/products/CreateForm'
import PlanList from '@/components/products/PlanList'
import TravelerTypeList from '@/components/products/TravelerTypeList'

export default {
  name: 'CreateStepForm',
  components: {
    CreateForm,
    PlanList,
    TravelerTypeList
  },

  props: {
    isSending: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeStep: 0,
      product: null,

      loadingAreas: false
    }
  },
  computed: {
    loading() {
      return this.loadingAreas || this.isSending
    }
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav)
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.preventNav)
  },
  methods: {
    preventNav(event) {
      if (this.activeStep === 1) {
        const travelerTypes = this.$refs.travelerTypeList.getTravelerTypes()

        if (travelerTypes.length === 0) {
          event.preventDefault()
          event.returnValue = ''
        }
      }
    },
    onCreate() {
      this.$refs.createForm.send()
    },
    async onSend(item) {
      this.$emit('onSend', item)
    },
    onCreated(product) {
      this.product = product
      this.activeStep = 1
    },
    onNext() {
      const travelerTypes = this.$refs.travelerTypeList.getTravelerTypes()

      if (travelerTypes.length === 0) {
        this.$buefy.dialog.confirm({
          message: this.$t('message.confirm_empty_traveler_types'),
          onConfirm: () => {
            this.$emit('onCompleted')
          }
        })
      } else {
        this.activeStep = 2
      }
    },
    onCompleted() {
      const plans = this.$refs.planList.getPlans()

      if (plans.length === 0) {
        this.$buefy.dialog.confirm({
          message: this.$t('message.confirm_empty_traveler_types'),
          onConfirm: () => {
            this.$emit('onCompleted')
          }
        })
      } else {
        this.$emit('onCompleted')
      }
    }
  }
}
</script>
